import { useQuery } from "@tanstack/react-query";

import useAxiosPrivate from "../../hooks/useAxiosPrivate";

function useStatisticsDailyWaterConsumption(
  year,
  month,
  day,
  params,
  options,
  key = "getDailyWaterConsumptionData",
) {
  const axiosPrivate = useAxiosPrivate();

  const getDailyWaterConsumptionData = async () => {
    const { data } = await axiosPrivate({
      method: "GET",
      url: `WaterConsumption/${year}/${month}/${day}`,
      params,
    });

    return data;
  };

  return useQuery(
    [key],
    () => getDailyWaterConsumptionData(year, month, params),
    {
      ...options,
    },
  );
}

export default useStatisticsDailyWaterConsumption;
